export default __webpack_public_path__ + "static/media/backend.323dc4eb.jpg";